module.exports = __webpack_public_path__ + "static/media/logo.bcd3e0b2.png";